import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';

const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const FormItem = Form.Item;

function UpdateForm({ form, item: { word, other_words = [] } }) {
  const { getFieldDecorator } = form;
  const placeholder = `词语1
词语2
词语3`;
  return (
    <Form>
      <FormItem label="词语" {...formItemLayout}>
        {getFieldDecorator('word', {
          rules: [{ required: true, message: '请输入百姓体词' }],
          initialValue: word,
        })(<Input />)}
      </FormItem>
      <FormItem label="同义词" {...formItemLayout} extra="多个同义词用换行分隔">
        {getFieldDecorator('other_words', {
          initialValue: Array.isArray(other_words)
            ? other_words.join('\n')
            : '',
        })(<Input.TextArea rows={3} placeholder={placeholder} />)}
      </FormItem>
    </Form>
  );
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default Form.create()(UpdateForm);
